// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"571":"de8aacb4","594":"89ed1719"}[chunkId] + ".chunk.js";
};